<script setup>
import { computed, inject } from 'vue';
import { Sparkles } from '@lucide/vue';

/**
 * Brand icon used as the AI mark across all designs. Resolves to:
 *   - `<img>` of `config.brandIconUrl` when the host sets one (e.g. a logo);
 *   - the lucide `Sparkles` icon by default.
 *
 * Sized in pixels to match the lucide icon's `size` prop, so callers don't
 * need to change anything when swapping a custom logo in or out.
 */
const props = defineProps({
    size: { type: [Number, String], default: 16 },
    strokeWidth: { type: [Number, String], default: 2.25 },
});

const config = inject('aia.config', null);
const url = computed(() => config?.brandIconUrl || null);
const px = computed(() => `${props.size}px`);
</script>

<template>
    <img
        v-if="url"
        :src="url"
        :width="20"
        :height="20"
        :style="{ width: px, height: px }"
        alt=""
        aria-hidden="true"
        class="aia-brand-icon"
    />
    <Sparkles v-else :size="size" :stroke-width="strokeWidth" />
</template>

<style scoped>
.aia-brand-icon {
    display: inline-block;
    object-fit: contain;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.15));
}
</style>
